/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { observer } from 'src/utils/mobx-react';
import React from 'react';
import {
    MultiplesColumnIdType,
    LiabilitiesMultiplesResponseType,
    LiabilitiesSinglesResponseType,
    MultiplesSelectionsType,
    SinglesColumnIdType,
    SinglesSelectionsType,
} from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesWidgets/LiabilitiesWidgetTable/LiabilitiesWidgetTable.types';
import { MultiplesTable } from './MultiplesTable';
import { SinglesTable } from './SinglesTable';
import { CurrencyType } from 'src_common/common/amount/website-money/currency';

type TablePropsType = {
    setSortDirection: (direction: string) => void;
    setSortedColumn: (column: MultiplesColumnIdType | SinglesColumnIdType) => void;
    sortColumn: string;
    sortDirection: string;
    selections: MultiplesSelectionsType | SinglesSelectionsType;
    liabilities: LiabilitiesSinglesResponseType | LiabilitiesMultiplesResponseType | null;
    isMultiplesWidget: boolean;
    columns: Array<SinglesColumnIdType> | Array<MultiplesColumnIdType>;
    currency: CurrencyType;
    eventId: number;
};

export const Table = observer(
    'LiabilitiesTable',
    ({
        setSortDirection,
        setSortedColumn,
        sortColumn,
        sortDirection,
        selections,
        liabilities,
        isMultiplesWidget,
        columns,
        currency,
        eventId,
    }: TablePropsType): JSX.Element => {
        const handleColumnSort = (column: MultiplesColumnIdType | SinglesColumnIdType): void => {
            if (sortColumn === column) {
                const direction = sortDirection === 'asc' ? 'desc' : 'asc';
                return setSortDirection(direction);
            }

            const direction = 'asc';
            setSortedColumn(column);
            setSortDirection(direction);
        };

        return isMultiplesWidget ? (
            <MultiplesTable
                columns={columns as Array<MultiplesColumnIdType>}
                selections={selections as MultiplesSelectionsType}
                sortColumn={sortColumn}
                sortDirection={sortDirection}
                handleColumnSort={handleColumnSort}
                currency={currency}
                eventId={eventId}
            />
        ) : (
            <SinglesTable
                columns={columns as Array<SinglesColumnIdType>}
                liabilities={liabilities as LiabilitiesSinglesResponseType}
                selections={selections as SinglesSelectionsType}
                sortColumn={sortColumn}
                sortDirection={sortDirection}
                handleColumnSort={handleColumnSort}
                currency={currency}
                eventId={eventId}
            />
        );
    }
);
